module.exports = __webpack_public_path__ + "img/polar-bear.3ed76da4.png";